import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { AppBar } from '@mui/material';

import DashboardNav from './DashboardNav';
import MerchantsNav from './MerchantsNav';
import MembersNav from './MembersNav';
import CampaignsNav from './CampaignsNav';
import PromotionsNav from './PromotionsNav';
import PerformanceNav from './PerformanceNav';
import GroupsNav from './GroupsNav';
import ChatNav from './ChatNav';
import DiscoverNav from './DiscoverNav';
import LookbookNav from './LookbookNav';

import SubNavbar from './components/SubNavbar';
import { getRouteName, normalizePath } from '../../utils/routesNames';
import { routes } from '../../pages';

import './_navbarMobile.scss';

const NavbarMobile = ({ open, toggleDrawer }) => {
  const { pathname } = useLocation();
  const normalizedPath = normalizePath(pathname);

  // still keep this special case for groups edit
  const groupEdit = pathname.includes('/my-creators/groups');
  const lookbookEdit = pathname.includes('/lookbook/edit');
  const lookbookInventory = pathname.includes('/lookbook/inventory');
  const lookbookPreview = pathname.includes('/lookbook/preview');

  const getNavbar = () => {
    if (normalizedPath === normalizePath(routes.root.path)) {
      return <DashboardNav open={open} toggleDrawer={toggleDrawer} />;
    }

    if (normalizedPath === normalizePath(routes.merchants.root.path)) {
      return <MerchantsNav />;
    }

    if (normalizedPath === normalizePath(routes.performance.path)) {
      return <PerformanceNav />;
    }

    if (
      normalizedPath === normalizePath(routes.members.list.path) ||
      normalizedPath === normalizePath(routes.members.invitations.path)
    ) {
      return <MembersNav />;
    }

    if (normalizedPath === normalizePath(routes.promotions.root.path)) {
      return <PromotionsNav redirect />;
    }

    if (normalizedPath === normalizePath(routes.campaigns.list.path)) {
      return <CampaignsNav redirect />;
    }

    if (normalizedPath === normalizePath(routes.chat.root.path)) {
      return <ChatNav redirect />;
    }

    if (normalizedPath === normalizePath(routes.discover.root.path)) {
      return <DiscoverNav redirect />;
    }

    if (normalizedPath === normalizePath(routes.lookbook.create.manual.path) || normalizedPath === normalizePath(routes.lookbook.create.shopify.path) || lookbookEdit || lookbookInventory) {
      return <LookbookNav />;
    }

    if (lookbookPreview) {
      return <LookbookNav isPreview />;
    }

    if (groupEdit) {
      return <GroupsNav />;
    }

    const routeTitle = getRouteName(pathname);

    return routeTitle && <SubNavbar route={routeTitle} />;
  };

  return (
    <div className="navbar-mobile">
      <AppBar position="static">
        {getNavbar()}
      </AppBar>
    </div>
  );
};

NavbarMobile.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired
};

export default NavbarMobile;
